/**
 * Кнопка с доступным фокусом и четырьмя вариантами оформления.
 *
 * `danger` — не украшение, а предупреждение: необратимое действие обязано
 * выглядеть иначе, чем продолжение занятия (ТЗ UI-24).
 *
 * Варианта «ошибка» у кнопки нет намеренно (UI-25): отказ действия — это
 * событие, а не постоянное состояние кнопки. Перекрашенная кнопка осталась бы
 * красной и после того, как причина ушла; сообщение рядом с ней исчезает
 * вместе с причиной и, в отличие от цвета, говорит, что именно случилось.
 */
import type { ButtonHTMLAttributes, ReactNode, Ref } from 'react';

export type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  readonly variant?: ButtonVariant;
  readonly children: ReactNode;
  /**
   * Ссылка на сам элемент: вызывающему бывает нужно вернуть ей фокус —
   * например, закрыв диалог, который эта кнопка открыла (ТЗ UI-34).
   */
  readonly ref?: Ref<HTMLButtonElement>;
}

export function Button({ variant = 'primary', children, ...rest }: ButtonProps): React.JSX.Element {
  return (
    <button type="button" className={`t2x-button t2x-button--${variant}`} {...rest}>
      {children}
    </button>
  );
}
